import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

/** ผลลัพธ์การสุ่ม variant ของ A/B experiment (ฝั่งผู้ตอบ) — backend คืนเฉพาะ variant ที่ถูกเลือกแล้วเท่านั้น */
export interface AbResolveIF {
  experiment_key: string;
  publish_key: string;
  label: string;
}

/**
 * เรียก endpoint สาธารณะเพื่อสุ่ม variant ของ A/B experiment
 * การสุ่มเป็นฝั่ง backend ทั้งหมด — FE เพียงรับ publish_key ที่ถูกเลือกมาเก็บแบบ sticky แล้วเปิดฟอร์มตามนั้น
 */
@Injectable({ providedIn: 'root' })
export class AbResolveService {
  constructor(private http: HttpClient) { }

  /** GET /api/AbExperiment/resolve/{experiment_key} → variant ที่ถูกสุ่ม (unwrap .data) */
  resolve(experimentKey: string): Observable<AbResolveIF> {
    return this.http
      .get(`/api/AbExperiment/resolve/${experimentKey}`)
      .pipe(map((res: any) => res.data as AbResolveIF));
  }
}
